module.exports = __webpack_public_path__ + "img/pic-JanusYeo.d7bb13bb.png";